module.exports = __webpack_public_path__ + "static/media/Harjot Khehra- Amended Motion Decision dated September 9- 2024.d120dd4a.pdf";